import { render, staticRenderFns } from "./TabDerechosRpc.vue?vue&type=template&id=3771e497"
import script from "./TabDerechosRpc.vue?vue&type=script&lang=js"
export * from "./TabDerechosRpc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3771e497')) {
      api.createRecord('3771e497', component.options)
    } else {
      api.reload('3771e497', component.options)
    }
    module.hot.accept("./TabDerechosRpc.vue?vue&type=template&id=3771e497", function () {
      api.rerender('3771e497', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/constitucionsociedades/TabDerechosRpc.vue"
export default component.exports